import { render, staticRenderFns } from "./DetailedContract.vue?vue&type=template&id=48dfe949&"
import script from "./DetailedContract.vue?vue&type=script&lang=js&"
export * from "./DetailedContract.vue?vue&type=script&lang=js&"
import style0 from "./DetailedContract.vue?vue&type=style&index=0&id=48dfe949&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports